/**
 * Desktop grid card bottom-bar quick add — quantity sync and click isolation.
 */
(function () {
  "use strict";

  var MIN_QTY = 1;
  var MAX_QTY = 99;

  function clampQty(value) {
    var num = parseInt(String(value), 10);
    if (isNaN(num) || num < MIN_QTY) return MIN_QTY;
    if (num > MAX_QTY) return MAX_QTY;
    return num;
  }

  function getFormInput(root) {
    return root.querySelector("[data-ks-grid-card-qty-input]");
  }

  function syncHiddenQty(root, qty) {
    var input = getFormInput(root);
    if (!input) return;
    input.value = String(qty);

    var formId = input.getAttribute("form");
    if (!formId) return;
    var form = document.getElementById(formId);
    if (!form) return;

    var hidden = form.querySelector("[data-ks-grid-card-qty-field]");
    if (hidden) hidden.value = String(qty);
  }

  function setQty(root, next) {
    var qty = clampQty(next);
    syncHiddenQty(root, qty);
    var minus = root.querySelector("[data-ks-grid-card-qty-minus]");
    if (minus) minus.disabled = qty <= MIN_QTY;
    return qty;
  }

  function onQtyClick(event) {
    var btn = event.target.closest(
      "[data-ks-grid-card-qty-minus], [data-ks-grid-card-qty-plus]"
    );
    if (!btn) return;

    var root = btn.closest("[data-ks-grid-card-quick-add]");
    if (
      !root ||
      (root.dataset.ksGridCardMode !== "add" &&
        root.dataset.ksGridCardMode !== "box_size")
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var input = getFormInput(root);
    var current = clampQty(input ? input.value : MIN_QTY);

    if (btn.matches("[data-ks-grid-card-qty-minus]")) {
      setQty(root, current - 1);
    } else {
      setQty(root, current + 1);
    }
  }

  function onQtyInput(event) {
    var input = event.target.closest("[data-ks-grid-card-qty-input]");
    if (!input) return;

    var root = input.closest("[data-ks-grid-card-quick-add]");
    if (!root) return;

    event.stopPropagation();
    setQty(root, input.value);
  }

  function isolateBarClicks(event) {
    var bar = event.target.closest("[data-ks-grid-card-quick-add]");
    if (!bar) return;
    event.stopPropagation();
  }

  function onSubmitClick(event) {
    var submit = event.target.closest(
      ".ks-grid-card-quick-add__submit[type='submit']"
    );
    if (!submit) return;

    var root = submit.closest("[data-ks-grid-card-quick-add]");
    if (!root) return;

    event.stopPropagation();

    var input = getFormInput(root);
    if (input) setQty(root, input.value);
  }

  function initRoot(root) {
    if (!root || root.dataset.ksGridCardInit === "true") return;
    root.dataset.ksGridCardInit = "true";

    if (
      root.dataset.ksGridCardMode === "add" ||
      root.dataset.ksGridCardMode === "box_size"
    ) {
      setQty(root, getFormInput(root)?.value || MIN_QTY);
    }
  }

  function updateIconSubmitState() {
    var isDesktop = window.matchMedia("(hover: hover) and (min-width: 990px)").matches;
    document.querySelectorAll(".ks-grid-card-icon-submit").forEach(function (btn) {
      if (isDesktop) {
        if (!btn.dataset.ksSavedForm) {
          btn.dataset.ksSavedForm = btn.getAttribute("form") || "";
        }
        btn.removeAttribute("form");
        btn.setAttribute("type", "button");
      } else {
        if (btn.dataset.ksSavedForm) {
          btn.setAttribute("form", btn.dataset.ksSavedForm);
        }
        btn.setAttribute("type", "submit");
      }
    });
  }

  function initAll() {
    document.querySelectorAll("[data-ks-grid-card-quick-add]").forEach(initRoot);
    updateIconSubmitState();

    if (window.KSShippingGate?.refreshStatusNotes) {
      window.KSShippingGate.refreshStatusNotes();
    }
  }

  if (document.body.dataset.ksGridCardQuickAddBound !== "true") {
    document.body.dataset.ksGridCardQuickAddBound = "true";

    document.addEventListener("click", onQtyClick);
    document.addEventListener("input", onQtyInput);
    document.addEventListener("click", onSubmitClick, true);
    document.addEventListener("click", isolateBarClicks);
    document.addEventListener("pointerdown", isolateBarClicks);

    document.addEventListener("shopify:section:load", initAll);

    var desktopMq = window.matchMedia("(hover: hover) and (min-width: 990px)");
    if (desktopMq.addEventListener) {
      desktopMq.addEventListener("change", updateIconSubmitState);
    } else if (desktopMq.addListener) {
      desktopMq.addListener(updateIconSubmitState);
    }

    if (window.KSShippingGate?.UPDATED_EVENT) {
      window.addEventListener(window.KSShippingGate.UPDATED_EVENT, function () {
        if (window.KSShippingGate?.refreshStatusNotes) {
          window.KSShippingGate.refreshStatusNotes();
        }
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
